renderTableLinearData = function(pivotData, rowAttrs, colAttrs){
  let result, thead,tr,tbody,th;
  result = document.createElement('table');
  result.className = 'table dataTable table-striped table-bordered mb-0 d-table-fixed';
  result.style.cssText = 'min-width: 100%';

  /********** thead *********/
  thead = document.createElement('thead');
  tr = document.createElement('tr');
  for( let i=0;i<rowAttrs.length;i++){
    //let arr = pivotData.series[colAttrs[i]];
    th = document.createElement('th');
    th.className = 'pvtAxisLabel';
    th.style.cssText = 'background-color: #b7b7b7;';
    th.textContent = rowAttrs[i];
    tr.appendChild(th);
  }
  for( let i=0;i<colAttrs.length;i++){
    //let arr = pivotData.series[colAttrs[i]];
    th = document.createElement('th');
    th.className = 'pvtAxisLabel';
    th.textContent = colAttrs[i];
    tr.appendChild(th);
  }
  thead.appendChild(tr);
  result.appendChild(thead);

  /********* tbody *********/
  tbody = document.createElement('tbody');
  let size = rowAttrs.length !== 0 ? pivotData.series[rowAttrs[0]].length: pivotData.series[colAttrs[0]].length;
  for(let j=0;j<size;j++){
    tr = document.createElement('tr');
    for(let i=0;i<rowAttrs.length;i++){
      th = document.createElement('th');
      th.className = 'pvtAxisLabel';
      th.textContent = pivotData.series[rowAttrs[i]][j];
      tr.appendChild(th);
    }
    for(let i=0;i<colAttrs.length;i++){
      //let arr = pivotData.series[colAttrs[i]];
      th = document.createElement('th');
      th.className = 'pvtAxisLabel';
      th.textContent = pivotData.series[colAttrs[i]][j];
      tr.appendChild(th);
    }
    tbody.appendChild(tr);
  }
  result.appendChild(tbody);
  return result;
}

renderTablePivotData = function(pivotData, rowAttrs, colAttrs, rowKeys, colKeys, opts){
  let aggregator, c, colKey, i, j, r, rowKey, td, totalAggregator, txt, val, x;
  let tr,tbody,th;
  /*********** Table ********/
  result = document.createElement('table');
  result.className = 'table dataTable table-striped table-bordered mb-0 d-table-fixed';
  result.style.cssText = 'min-width: 100%';
  let spanSize = function(arr, i, j) {
    let l, len, n, noDraw, ref, ref1, stop, x;
    if (i !== 0) {
      noDraw = true;
      for (x = l = 0, ref = j; 0 <= ref ? l <= ref : l >= ref; x = 0 <= ref ? ++l : --l) {
        if (arr[i - 1][x] !== arr[i][x]) {
          noDraw = false;
        }
      }
      if (noDraw) {
        return -1;
      }
    }
    len = 0;
    while (i + len < arr.length) {
      stop = false;
      for (x = n = 0, ref1 = j; 0 <= ref1 ? n <= ref1 : n >= ref1; x = 0 <= ref1 ? ++n : --n) {
        if (arr[i][x] !== arr[i + len][x]) {
          stop = true;
        }
      }
      if (stop) {
        break;
      }
      len++;
    }
    return len;
  };

  /********** thead *********/
  let thead = document.createElement('thead');
  for (j in colAttrs) {
    if (!colAttrs.hasOwnProperty(j)) continue;
    c = colAttrs[j];
    tr = document.createElement('tr');
    if (parseInt(j) === 0 && rowAttrs.length !== 0) {
      th = document.createElement('th');
      th.setAttribute('colspan', rowAttrs.length);
      th.setAttribute('rowspan', colAttrs.length);
      tr.appendChild(th);
    }
    th = document.createElement('th');
    th.className = 'pvtAxisLabel';
    th.textContent = c;
    tr.appendChild(th);
    for (i in colKeys) {
      if (!colKeys.hasOwnProperty(i)) continue;
      colKey = colKeys[i];
      x = spanSize(colKeys, parseInt(i), parseInt(j));
      if (x !== -1) {
        th = document.createElement('th');
        th.className = 'pvtColLabel';
        th.textContent = colKey[j];
        th.setAttribute('colspan', x);
        if (parseInt(j) === colAttrs.length - 1 && rowAttrs.length !== 0) {
          th.setAttribute('rowspan', 2);
        }
        tr.appendChild(th);
      }
    }
    if (parseInt(j) === 0 && opts.table.rowTotals) {
      th = document.createElement('th');
      th.className = 'pvtTotalLabel pvtRowTotalLabel';
      th.innerHTML = opts.localeStrings.totals;
      th.setAttribute('rowspan', colAttrs.length + (rowAttrs.length === 0 ? 0 : 1));
      tr.appendChild(th);
    }
    thead.appendChild(tr);
  }
  if (rowAttrs.length !== 0) {
    tr = document.createElement('tr');
    for (i in rowAttrs) {
      if (!rowAttrs.hasOwnProperty(i)) continue;
      r = rowAttrs[i];
      th = document.createElement('th');
      th.className = 'pvtAxisLabel';
      th.textContent = r;
      tr.appendChild(th);
    }
    th = document.createElement('th');
    if (colAttrs.length === 0) {
      th.className = 'pvtTotalLabel pvtRowTotalLabel';
      th.innerHTML = opts.localeStrings.totals;
    }
    tr.appendChild(th);
    thead.appendChild(tr);
  }
  result.appendChild(thead);

  let getClickHandler;
  if (opts.table.clickCallback) {
    getClickHandler = function(value, rowValues, colValues) {
      let attr, filters, i;
      filters = {};
      for (i in colAttrs) {
        if (!colAttrs.hasOwnProperty(i)) continue;
        attr = colAttrs[i];
        if (colValues[i] != null) {
          filters[attr] = colValues[i];
        }
      }
      for (i in rowAttrs) {
        if (!rowAttrs.hasOwnProperty(i)) continue;
        attr = rowAttrs[i];
        if (rowValues[i] != null) {
          filters[attr] = rowValues[i];
        }
      }
      return function(e) {
        return opts.table.clickCallback(e, value, filters, pivotData);
      };
    };
  }

  /********* tbody *********/
  tbody = document.createElement('tbody');
  for (i in rowKeys) {
    if (!rowKeys.hasOwnProperty(i)) continue;
    rowKey = rowKeys[i];
    tr = document.createElement('tr');
    for (j in rowKey) {
      if (!rowKey.hasOwnProperty(j)) continue;
      txt = rowKey[j];
      x = spanSize(rowKeys, parseInt(i), parseInt(j));
      if (x !== -1) {
        th = document.createElement('th');
        th.className = 'pvtRowLabel';
        th.textContent = txt;
        th.setAttribute('rowspan', x);
        if (parseInt(j) === rowAttrs.length - 1 && colAttrs.length !== 0) {
          th.setAttribute('colspan', 2);
        }
        tr.appendChild(th);
      }
    }
    for (j in colKeys) {
      if (!colKeys.hasOwnProperty(j)) continue;
      colKey = colKeys[j];
      aggregator = pivotData.getAggregator(rowKey, colKey);
      val = aggregator.value();
      td = document.createElement('td');
      td.className = 'pvtVal row' + i + ' col' + j;
      td.textContent = aggregator.format(val);
      td.setAttribute('data-value', val);
      if (getClickHandler != null) {
        td.onclick = getClickHandler(val, rowKey, colKey);
      }
      tr.appendChild(td);
    }
    if (opts.table.rowTotals || colAttrs.length === 0) {
      totalAggregator = pivotData.getAggregator(rowKey, []);
      val = totalAggregator.value();
      td = document.createElement('td');
      td.className = 'pvtTotal rowTotal';
      td.textContent = totalAggregator.format(val);
      td.setAttribute('data-value', val);
      if (getClickHandler != null) {
        td.onclick = getClickHandler(val, rowKey, []);
      }
      td.setAttribute('data-for', 'row' + i);
      tr.appendChild(td);
    }
    tbody.appendChild(tr);
  }

  if (opts.table.colTotals || rowAttrs.length === 0) {
    tr = document.createElement('tr');
    if (opts.table.colTotals || rowAttrs.length === 0) {
      th = document.createElement('th');
      th.className = 'pvtTotalLabel pvtColTotalLabel';
      th.innerHTML = opts.localeStrings.totals;
      th.setAttribute('colspan', rowAttrs.length + (colAttrs.length === 0 ? 0 : 1));
      tr.appendChild(th);
    }
    for (j in colKeys) {
      if (!colKeys.hasOwnProperty(j)) continue;
      colKey = colKeys[j];
      totalAggregator = pivotData.getAggregator([], colKey);
      val = totalAggregator.value();
      td = document.createElement('td');
      td.className = 'pvtTotal colTotal';
      td.textContent = totalAggregator.format(val);
      td.setAttribute('data-value', val);
      if (getClickHandler != null) {
        td.onclick = getClickHandler(val, [], colKey);
      }
      td.setAttribute('data-for', 'col' + j);
      tr.appendChild(td);
    }
    if (opts.table.rowTotals || colAttrs.length === 0) {
      totalAggregator = pivotData.getAggregator([], []);
      val = totalAggregator.value();
      td = document.createElement('td');
      td.className = 'pvtGrandTotal';
      td.textContent = totalAggregator.format(val);
      td.setAttribute('data-value', val);
      if (getClickHandler != null) {
        td.onclick = getClickHandler(val, [], []);
      }
      tr.appendChild(td);
    }
    tbody.appendChild(tr);
  }

  result.appendChild(tbody);
  result.setAttribute('data-numrows', rowKeys.length);
  result.setAttribute('data-numcols', colKeys.length);
  return result;

}
